"use client";

import { Text } from "@marketplace/ui";
import { cva } from "class-variance-authority";
import { useTranslation } from "react-i18next";

export type TransactionStatusPillStatus =
  | "new"
  | "order_created"
  | "waiting_for_payment"
  | "payment_verified"
  | "paid"
  | "done"
  | "failed"
  | "active"
  | "cancelled";

type TransactionStatusPillProps = {
  status: TransactionStatusPillStatus;
  customLabel?: string;
};

const statusPill = cva(
  "flex justify-center items-center w-[148px] h-6 rounded",
  {
    variants: {
      status: {
        new: "bg-[#ECDEFF] text-[#994EFF]",
        order_created: "bg-[#ECDEFF] text-[#994EFF]",
        waiting_for_payment: "bg-[#FEFFDE] text-[#929618]",
        payment_verified: "bg-[#ECDEFF] text-[#994EFF]",
        paid: "bg-[#E5FFDE] text-[#45B527]",
        done: "bg-[#E5FFDE] text-[#45B527]",
        failed: "bg-[#FFE7E7] text-[#8B1515]",
        active: "bg-[#E5FFDE] text-[#45B527]",
        cancelled: "bg-[#FFE7E7] text-[#8B1515]"
      }
    }
  }
);

export const TransactionStatusPill = ({
  status,
  customLabel
}: TransactionStatusPillProps) => {
  const { t } = useTranslation("common");

  const statusLabel: Record<TransactionStatusPillStatus, string> = {
    new: t("transactionStatus.waitingForResponse"),
    order_created: t("transactionStatus.orderCreated"),
    waiting_for_payment: t("transactionStatus.waitingForPayment"),
    payment_verified: t("transactionStatus.waitingForResponse"),
    paid: t("transactionStatus.paid"),
    done: t("transactionStatus.done"),
    failed: t("transactionStatus.failed"),
    active: t("transactionStatus.active"),
    cancelled: t("transactionStatus.cancelled")
  };

  return (
    <div className={statusPill({ status })}>
      <Text>{customLabel || statusLabel[status]}</Text>
    </div>
  );
};
